export default function GsapParallaxModule(element) {
    let movement = gsap.utils.random(50, 100);

    gsap.fromTo(element, 
        {
            y: movement * -1
        },
        {
            scrollTrigger: { 
                scrub: 1,
                start: 'center center'
            },
            y: movement
        }
    );
}
